import { render } from "./AddParcel.vue?vue&type=template&id=c74ab5d6"
import script from "./AddParcel.vue?vue&type=script&lang=js"
export * from "./AddParcel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__